import { Routes, Route } from 'react-router-dom';
import Login from '../pages/Login/login';
// import Dashboard from '../pages/Dashboard/Dashboard';
import Dashboard from '../pages/Dashboard/index';
import CryptoTest from '../pages/CryptoTest/CryptoTest';
import AppLayout from '../layouts/Applayout';
import TestDashboard from '../pages/TestDashboard/TestDashboard';
import DynamicPage from './DynamicRoutes';
import ResetPassword from 'pages/reset/ResetPassword';
import ItkSupportRoutes from '../pages/itk-support';
import EntranceClass from 'pages/admin-panel/entrance-class/EntranceClass';
import OrientationAttendance from 'pages/admin-panel/orientation-attendance/OrientationAttendance';
import DigitalContentModule from 'pages/digital-content';
import InboxModule from 'pages/inbox';
import NsnopModule from 'pages/nsnop';
import ApprovalModule from 'pages/approval';
import ReportsModule, { PpObservationReportPage } from 'pages/reports';
import CompetitionModule from 'pages/competition';
import EventsModule from 'pages/events';
import MailRequestDashboard from 'pages/mail-request/MailRequestDashboard';
import PageNotFound from 'pages/PageNotFound/PageNotFound';
import { getSessionData } from 'utils.session';
import PallipaarvaiDashboard from 'pages/pallipaarvai/dashboard/PallipaarvaiDashboard';

// Guard: only admin user (4028619) or HR users (usertype=21, usertype1=23) can access
const MailRequestGuard = () => {
  const storedUsername = localStorage.getItem('username') || '';
  const backUser = localStorage.getItem('backUser') || '';
  const effectiveUsername = backUser ? '' : storedUsername;
  const session = getSessionData();
  const userType = Number(session?.usertypeid) || 0;
  const userType1 = Number(session?.emisUsertype1) || 0;
  const isAllowed =
    effectiveUsername === '4028619' || (userType === 21 && userType1 === 23);

  if (!isAllowed) {
    return <PageNotFound />;
  }
  return <MailRequestDashboard />;
};

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/auth/login" element={<Login />} />

      <Route element={<AppLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/crypto-test" element={<CryptoTest />} />
        <Route path="/testDashboard" element={<TestDashboard />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/itk-support/*" element={<ItkSupportRoutes />} />
        <Route path="/admin-panel/entrance-class" element={<EntranceClass />} />
        <Route
          path="/admin-panel/orientation-attendance"
          element={<OrientationAttendance />}
        />
        <Route path="/Digital/*" element={<DigitalContentModule />} />
        <Route path="/inbox/*" element={<InboxModule />} />
        <Route path="/nsnop/*" element={<NsnopModule />} />
        <Route path="/approval/*" element={<ApprovalModule />} />
        <Route path="/component/reports/*" element={<ReportsModule />} />
        <Route
          path="/component/pp-observation-report"
          element={<PpObservationReportPage />}
        />
        <Route path="/competition/*" element={<CompetitionModule />} />
        <Route path="/events/*" element={<EventsModule />} />
        <Route path="/mail-request" element={<MailRequestGuard />} />
        <Route
          path="component/new_health_dashboard"
          element={<OrientationAttendance />}
        />
        <Route
          path="component/pp_dashboard"
          element={<PallipaarvaiDashboard />}
        />
        {/* Catch-all MUST be last — redirects unmatched paths to Angular */}
        <Route path="*" element={<DynamicPage />} />
      </Route>
    </Routes>
  );
}
